import {Params, ActivatedRoute, Router} from "@angular/router";
import {OnInit} from "@angular/core";

export type RouteMapping = {
  paramName: string;
  fieldName: string;
  defaultValue: any;
  type: string;
};

export abstract class RouteHelper implements OnInit {
  private static converters = {
    number: x => +x,
    boolean: x => `${x}`.toLowerCase() === "true",
  };

  abstract paramsMap: RouteMapping[] = [];
  abstract route: ActivatedRoute;
  abstract router: Router;

  public setFormReturnsNewObject: boolean = false;

  abstract loadData(): any;
  abstract navigate(queryParams: Params, skipLocationChange: boolean): Promise<boolean>;

  public getFormData(): Params {
    return this;
  }

  public setFormData(params: Params) {
    Object.assign(this as any, params);
  }

  public watchRoute(): void {
    this.route.queryParams.forEach((params: Params) => {
      const inForm: Params = this.getFormData();
      const outForm: Params = this.setFormReturnsNewObject ? {} : inForm;
      let somethingWasChanged = false;
      const paramsClone = {};
      
      this.paramsMap.forEach(({paramName, fieldName, defaultValue, type}) => {
        if (type && Object.prototype.hasOwnProperty.call(params, paramName) && RouteHelper.converters[type]) {
          paramsClone[paramName] = RouteHelper.converters[type](params[paramName]);
        } else {
          paramsClone[paramName] = params[paramName];
        }
        if (inForm[fieldName] !== paramsClone[paramName] && paramsClone[paramName]) {
          outForm[fieldName] = paramsClone[paramName];
        } else {
          outForm[fieldName] = inForm[fieldName];
        }

        if (
          (inForm[fieldName] === undefined || `${inForm[fieldName]}` === `${defaultValue}`) &&
          outForm[fieldName] === undefined &&
          defaultValue !== undefined
        ) {
          outForm[fieldName] = defaultValue;
          somethingWasChanged = true;
        }
      });

      if (somethingWasChanged) {
        this.setFormData(outForm);
        this.syncRoute(true);
        return;
      }

      this.setFormData(outForm);
      this.loadData();
    });
  }

  public syncRoute(skipLocationChange = false): Promise<boolean> {
    const queryParams: Params = {};
    const form: Params = this.getFormData();

    this.paramsMap.forEach(({paramName, fieldName}) => {
      const value = form[fieldName] ? form[fieldName] : "";

      if (value !== undefined && value !== null && value !== "") {
        queryParams[paramName] = form[fieldName];
      }
    });

    return this.navigate(queryParams, skipLocationChange);
  }

  public ngOnInit(): void {
    this.watchRoute();
  }

  constructor() {

  }
}
